<div class="d-flex flex-column gap-2">
	<h4>Current Status</h4>
	<div class="d-flex flex-column gap-4">
		<!-- Hidden original select field to maintain form registration -->
		<div class="d-none">
			<common-select-field [field]="status()"></common-select-field>
		</div>
		<dashboard-descriptive-select-field [showSubTextInValue]="false" [items]="descriptiveStatusItems()"
			[selectedItem]="selectedDescriptiveItem()" [placeholder]="'Select a status...'" [label]="'Status'"
			[disabled]="!isDescriptiveSelectEnabled()" [customIcon]="currentStatusIcon()" [enableSorting]="false"
			(selectionChange)="onDescriptiveSelectionChange($event)">
		</dashboard-descriptive-select-field>
		<common-select-field [field]="attendedOrientation()"></common-select-field>
		<common-multiselect-field [field]="languages()"></common-multiselect-field>
		<common-multiselect-field [field]="roles()"></common-multiselect-field>
		<common-multiselect-field [field]="topics()"></common-multiselect-field>
		<common-text-field [field]="notes()"></common-text-field>
		<common-button-row [center]="true">
			<button #statusSaveBtn class="btn btn-standard"
				[disabled]="!dialogDataService.hasVolunteerEditPermissions()">
				Save
			</button>
			<button class="btn btn-standard" [disabled]="!dialogDataService.hasVolunteerEditPermissions()"
				(click)="revertChanges()">
				Revert
			</button>
		</common-button-row>
	</div>
</div>